import HomeSlider from '../ones/HomeSlider';
import FeaturesSection from '../ones/FeaturesSection';
import ProductPreviewSection from '../ones/ProductPreviewSection';
import ClientsSection from '../ones/ClientsSection';
import InquiryCta from '../ones/InquiryCta';
import Footer from '../ones/Footer';

export default function HomeLanding() {
  return <><HomeSlider /><FeaturesSection /><ProductPreviewSection /><ClientsSection /><InquiryCta /><Footer /></>;
}
